module.exports = __webpack_public_path__ + "static/media/basil.1f8ba660.webp";